import styled from "styled-components";
import {CheckboxInputBox} from "../../../../../../../basic-ui-components/form/checkboxinput.box";

export const JBOptinReminderCheckboxDefaultBox = styled(CheckboxInputBox)`
    width: 2.4em;
    height: 2.4em;
    margin-right: 16px;
`;